"use client";

import Link from "next/link";
import { PlayStore } from "../icons/PlayStore";
import { AppStore } from "../icons/AppStore";
import { FaInstagram, FaLinkedin, FaTiktok, FaXTwitter } from "react-icons/fa6";
import { useCookieConsent } from "react-cookie-manager";

export const Footer = () => {
	const { showConsentBanner } = useCookieConsent();

	return (
		<div
			className="footer"
			style={{
				background: "#19181a",
				backgroundImage:
					"url(/images/svg/bg_009.svg), linear-gradient(180deg, #19181a 0%, #000000 100%)",
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			<div className="footer__content">
				<div className="footer__content__text">
					<h3>Join the ApolloFit community</h3>
				</div>
				<div className="banners">
					<div className="banner">
						<Link href="https://apps.apple.com/us/app/apollofit/id1668675980">
							<AppStore width={120} />
						</Link>
					</div>

					<div className="banner">
						<Link href="https://play.google.com/store/apps/details?id=com.apollofit.apollo&pcampaignid=web_share">
							<PlayStore width={120} />
						</Link>
					</div>
				</div>

				<div className="footer__links">
					<Link href="https://instagram.com/apollofitapp">
						<FaInstagram size={24} />
					</Link>
					<Link href="https://www.linkedin.com/company/apollofit/">
						<FaLinkedin size={24} />
					</Link>
					<Link href="https://www.tiktok.com/@apollofitapp">
						<FaTiktok size={24} />
					</Link>
					<Link href="https://x.com/apollofitapp">
						<FaXTwitter size={24} />
					</Link>
				</div>

				<div className="footer__links footer__links--text">
					<Link href="/contact">Contact</Link>
					<a onClick={showConsentBanner}>Manage cookies</a>
					<Link href="/trainers">Trainers</Link>
					<Link href="/roadmap">Roadmap</Link>
				</div>

				<div className="footer__links footer__links--text">
					<Link href="/privacy-policy">Privacy Policy</Link>
					<Link href="/terms-and-conditions">Terms and Conditions</Link>
					<Link href="/code-of-conduct">Code of Conduct</Link>
					<Link href="/health-and-safety-disclaimer">
						Health and Safety Disclaimer
					</Link>
					<Link href="/refund-policy">Refund Policy</Link>
					<Link href="/trainer-agreement">Trainer Agreement</Link>
				</div>
				<div className="footer__links ">
					<p>&copy; {new Date().getFullYear()} ApolloFit</p>
				</div>
			</div>
		</div>
	);
};
